import { AccordionProps } from "Componentes/Accordion/AccordionItem";

export const Questions: Array<AccordionProps> = [
  {
    answer: "Tengo un determinado tiempo para resolver las tareas de la guía?",
    reply:
      "No. Pero evitá los extremos: no te apures ni tampoco te tomes todo el tiempo del mundo."
  },
  {
    answer: "Que pasa si me trabo o no sé algo?",
    reply:
      "Primero, googlealo, investigá un poco. En la web hay mucha info y eso te ayudará bastante. Si ves que no hay chances de seguir o no encontras lo que buscas, preguntale a alguno de tus compañeros, te van a saber ayudar."
  },
  {
    answer: "Como hago para cambiar/modificar algo que ya hice?",
    reply:
      "Los cambios se hacen en la rama correspondiente. En este caso es: bugfix/Nombre-de-la-rama."
  },
  {
    answer: "Como agrego mas Preguntas Frecuentes?",
    reply:
      "Vas a Contents > PreguntasFrecuentes > Questions.ts. En dicho archivo agregas la pregunta en Answer y la respuesta en Reply."
  }
];
